import React from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { NavLink, useHistory, useParams } from 'react-router-dom'

import { ApplicationState } from 'AppReducer'
import { deleteAddress } from './redux/actions'

type AddOpts = { person?: number, hideEmpty?: boolean, disableActions?: boolean, }
const AddressList: React.FC<AddOpts> = ({ person, hideEmpty = false, disableActions = false }) => {
  const dispatch = useDispatch()
  const history = useHistory()

  const { personId: routePerson } = useParams<{ personId: string }>()
  const { addresses } = useSelector((state: ApplicationState) => state.userAddressReducer)

  const personId = routePerson || person

  function handleRemove (id: number): void {
    if (personId && window.confirm('Tem certeza que deseja remover?')) {
      deleteAddress(personId, id)(dispatch).then(res => {
        if (res?.status === 'success') {
          history.push(person ? '/panel/profile' : `/panel/person/${personId}/address`)
        }
      })
    }
  }
  if (hideEmpty && !addresses.length) {
    return null
  }

  return (
    <div className="row justify-start margin-top-32">
      <h2>Endereços Cadastrados</h2>
      {
        addresses.length === 0 &&
        <p className="row empty">Nenhum endereço cadastrado</p>
      }

      {
        addresses.map(address => (
          <div className="row tile" key={address.id}>
            <div className="grow">
              <div className="row">
                <div className="row col-2">
                  <p className="col-12 bold">Nome</p>
                  <p className="col-12 no-margin">{ address.alias }</p>
                </div>
                <div className="row col-10">
                  <p className="col-12 bold">Endereço</p>
                  <p className="col-12 no-margin">
                    { address.street }, Nº { address.number || 'S/N' } ({ address.complement })
                    - { address.district }, { address.city } - {address.state}
                  </p>
                </div>
              </div>
            </div>
            {
              !disableActions &&
              <>
                <span
                  style={{ width: 48 }}
                  onClick={(): void => handleRemove(address.id)}
                  className="button remove margin-right-8"
                >
                  <i className="fa fa-trash"/>
                </span>
                <NavLink
                  style={{ width: 48 }}
                  className="button primary"
                  to={
                    person
                      ? `/panel/profile/address/${address.id}/edit`
                      : `/panel/person/${personId}/address/${address.id}/edit`
                  }
                >
                  <i className="fa fa-edit"/>
                </NavLink>
              </>
            }
          </div>
        ))
      }
    </div>
  )
}

export default AddressList
